import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

/**
 * Shell de produto técnico:
 *   ┌────────┬─────────────────────────────────────────┐
 *   │        │              Topbar                     │
 *   │ Sidebar├─────────────────────────────────────────┤
 *   │ (dark) │                                         │
 *   │        │              Content (Outlet)           │
 *   │        │                                         │
 *   └────────┴─────────────────────────────────────────┘
 *
 * Sidebar fixa, Topbar fina, content rola independente.
 */
export function AppShell() {
  return (
    <div className="h-screen flex overflow-hidden bg-background">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 overflow-y-auto bg-background">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
